import React from "react";
import { useState, useEffect } from "react";
import CreateMcq from "./CreateMcq";
import CreateUploadType from "./CreateUploadType";
import { Popup } from "semantic-ui-react";
import axios from "../../../../../axios";
import CrossAttachmentAssessment from "../../../../../Assesment/pages/Create_Assessment/Attachment/CrossAttachmentAssessment";
import QuestionThreeDotPopup from "../QuestionThreeDotPopup";
import Guides from "./Guides";

export default function DefaultQuestion({
  nextQuestion,
  question,
  setQuestions,
  assessmentDetails,
  qArr,
  setSkillsData,
  setQuestionType,
  setDifficulty_levelData
}) {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  let school_id = JSON.parse(localStorage.getItem("schoolId"));
  const timeTableSessionId = JSON.parse(localStorage.getItem('timeTableSessionId'))

  const [fLimit, setFLimit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [marksE, setMarksE] = useState("");
  const [addHW, setAddHW] = useState("")
  const [click, setClick] = useState(false)
  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const [dropdownList, setDropdownList] = useState({
    skills: null,
    types: null,
    domains: null,
    chapters: null,
    difficultyLevels: null,
  });
  const { skills, types, domains, chapters, difficultyLevels } = dropdownList;
  useEffect(() => {
    try {
      const getDetails = async () => {
        let skills = await axios.get(`/api/v1/school/skill/get`);
        if (skills) {
          setDropdownList((prev) => ({ ...prev, skills: skills.data.data }));
          setSkillsData(skills.data.data)
        }

        let chapters = await axios.get(
          //TBD:New book info url integration
          `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${assessmentDetails?.standard_id?.id}&section_id=${assessmentDetails?.section_id?.id}&subject_id=${assessmentDetails?.subject_id?.id}&timetableSessionId=${timeTableSessionId}`
          // `/api/v1/school/book/get/standardId/${assessmentDetails?.standard_id?.id}?sectionId=${assessmentDetails?.section_id?.id}&subjectId=${assessmentDetails?.subject_id?.id}&isWithChapters=true`
        );
        // console.log(chapters);
        chapters &&
          setDropdownList((prev) => ({ ...prev, chapters: chapters.data.data }));

        let domains = await axios.get(`/api/v1/school/domain/get`);
        domains &&
          setDropdownList((prev) => ({ ...prev, domains: domains.data.data }));

        let types = await axios.get(
          `/api/v1/questionType/get/school/${school_id}`
        );
        if (types) {
          setDropdownList((prev) => ({ ...prev, types: types.data.data }));
          setQuestionType(types.data.data)
        }

        let difficultyLevels = await axios.get(`/api/v1/difficultyLevel/get`);
        if (difficultyLevels) {
          setDropdownList((prev) => ({
            ...prev,
            difficultyLevels: difficultyLevels.data.data,
          }));
          setDifficulty_levelData(difficultyLevels.data.data)
        }
      };
      getDetails();
    } catch (error) {
      console.log(error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // console.log(dropdownList);
  const handleAttachment = async (files) => {
    let attachments = [];
    let attachments_sizeKb = [];
    setLoader(true);
    const maxSize = 10 * 1024 * 1024; // 25MB in bytes
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > maxSize) {
        setFLimit(true);
        return;
      }
    }
    if (files) {
      for (const file of files) {
        try {
          let formData = new FormData();
          formData.append("name", file.name);
          formData.append("uploadQuestionAttachment", file);
          let res = await axios.post(
            `/api/v1/question/uploadAttachment/teacherId/${teacher_id}`,
            formData
          );
          attachments_sizeKb.push(Math.round(file.size / 1024));
          res && attachments.push(res.data.data);
          res && setFLimit(false);
          res && setLoader(false);
        } catch (error) {
          setLoader(false);
          console.log(error);
        }
      }
      if (attachments.length > 0) {
        setQuestions((prev) => {
          const updatedQuestion = {
            ...prev[nextQuestion],
            attachments: attachments,
            attachments_sizeKb,
          };
          const newQuestion = [...prev];
          newQuestion[nextQuestion] = updatedQuestion;
          return newQuestion;
        });
      }
    }
  };
  // console.log(question,"question");
  return (
    <>
      <div className="d-flex align-items-center justify-content-center ">
        <div className="col-11 m-0 mt-2 p-3 question_box_container  ">
          <div
            className="d-flex"
            style={{
              marginTop: "10px",
            }}
          >
            <div className="hw_question_no me-2">Q{nextQuestion + 1}</div>
            <input
              onChange={(e) => {
                const value = e.target.value;
                // I allow these some special character for question input field
                setAddHW(value)
                setQuestions((prev) => {
                  const updatedQuestion = {
                    ...prev[nextQuestion],
                    title: value,
                  };
                  const newQuestion = [...prev];
                  newQuestion[nextQuestion] = updatedQuestion;
                  return newQuestion;
                })
              }

              }
              className="hw_question_box "
              placeholder="Add question"
              value={question.title ? question.title : addHW}
              maxlength="250"
            />
            {qArr && qArr.length > 1 ? (
              <Popup
                on="click"
                open={popupOpen}
                onClose={handleClosePopup}
                trigger={
                  <div
                    className="hw_three_dots"
                    onClick={() => setPopupOpen((prev) => !prev)}
                  >
                    <img src="/images/three dot hr.svg" alt="" />
                  </div>
                }
                content={
                  <div className="hw_popup_box_size" onClick={handleClosePopup}>
                    <QuestionThreeDotPopup
                      questionIndex={nextQuestion}
                      setQuestions={setQuestions}
                    />
                  </div>
                }
              />
            ) : (
              <></>
            )}
          </div>
          <div className=" mt-2 d-flex align-items-center hw_default_dropdown_container ">
            {/* <div>&nbsp; &nbsp;</div> */}
            <div className=" hw_default_dropdown_size">
              <span className="hw_default_dropdown_box_header">
                KNOWLEDGE DOMAIN
              </span>
              <select
                onChange={(e) =>
                  setQuestions((prev) => {
                    const updatedQuestion = {
                      ...prev[nextQuestion],
                      domain_id: e.target.value,
                    };
                    const newQuestion = [...prev];
                    newQuestion[nextQuestion] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question.domain_id}
                label={domains?.some((d) => d.id === question.domain_id).name}
                className="form-select hw_default_sub_dropdown_size"
              >
                <option value="null">Select Knowledge Domain</option>
                {domains &&
                  domains.map((domain, index) => (
                    <option key={index} value={domain.id}>
                      {domain.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="hw_default_dropdown_size" style={{ position: "relative" }}>
              <span className="hw_default_dropdown_box_header">SKILLS</span>
              <select
                onChange={(e) =>
                  setQuestions((prev) => {
                    const updatedQuestion = {
                      ...prev[nextQuestion],
                      skill_id: e.target.value,
                    };
                    const newQuestion = [...prev];
                    newQuestion[nextQuestion] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question.skill_id}
                label={skills?.some((s) => s.id === question.skill_id).name}
                className="form-select hw_default_sub_dropdown_size"
              >
                <option value="null" placeholder="dd">
                  Select Skill
                </option>
                {skills &&
                  skills?.map((skill, index) => (
                    <option key={index} value={skill.id} placeholder="dd">
                      {skill.name}
                    </option>
                  ))}
              </select>
              <span onClick={() => setClick(true)} style={{ position: "absolute", left: "45%", fontSize: "12px", color: "red", cursor: "pointer" }}>Click here to more details</span>
            </div>
            <div className="hw_default_dropdown_size">
              <span className="hw_default_dropdown_box_header">
                TYPE OF QUESTION
              </span>

              <select
                onChange={(e) =>
                  setQuestions((prev) => {
                    let updatedQuestion;
                    if (
                      e.target.options[e.target.selectedIndex].getAttribute(
                        "data-is-manually-graded"
                      ) === "true"
                    ) {
                      updatedQuestion = {
                        ...prev[nextQuestion],
                        type_id: e.target.value,
                        question_type: String(
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "data-is-manually-graded"
                          )
                        ),
                        options: [],
                        correct_answers: [
                          {
                            reason_for_answer: {
                              explanation: null,
                              attachments: null,
                            },
                          },
                        ],
                      };
                    } else {
                      updatedQuestion = {
                        ...prev[nextQuestion],
                        type_id: e.target.value,
                        question_type: String(
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "data-is-manually-graded"
                          )
                        ),
                        options: [
                          {
                            key: String.fromCharCode(0 + 65),
                            value: null,
                          },
                          {
                            key: String.fromCharCode(1 + 65),
                            value: null,
                          },
                        ],
                      };
                    }

                    const newQuestion = [...prev];
                    newQuestion[nextQuestion] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question.type_id}
                label={types?.some((t) => t.id === question.type_id).name}
                className="form-select hw_default_sub_dropdown_size"
              >
                <option value="null">Select QuestionType</option>
                {types &&
                  types?.map((type, index) => (
                    <option
                      key={index}
                      value={type.id}
                      data-is-manually-graded={type?.is_manually_graded}
                    >
                      {type.name}
                    </option>
                  ))}
              </select>
            </div>
            <div
              // style={{ marginTop: "-6px" }}
              className="hw_default_dropdown_card"
            >
              <span className="hw_default_dropdown_box_header">CHAPTER</span>
              <select
                id="bookChapterSelect"
                className="hw_default_sub_dropdown_size form-select"
                onChange={(e) =>
                  setQuestions((prev) => {
                    const updatedQuestion = {
                      ...prev[nextQuestion],
                      chapter_id: e.target.value,
                      book_id:
                        e.target.options[e.target.selectedIndex].getAttribute(
                          "book-id"
                        ),
                    };
                    const newQuestion = [...prev];
                    newQuestion[nextQuestion] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question.chapter_id}
              >
                <option value="null">Select Chapter</option>
                {chapters?.length > 0 &&
                  chapters?.map((item) =>
                    item.bookInfo.map((book) => (
                      <optgroup
                        label={book.name}
                        key={book.id}
                        book-id={book.id}
                      >
                        {book.chapterData.map((chapter) => (
                          <option
                            key={chapter.id}
                            book-id={book.id}
                            book-name={book.name}
                            value={chapter.id}
                          >
                            {chapter.chapterName}
                          </option>
                        ))}
                      </optgroup>
                    ))
                  )}
              </select>
              {/* <select
                id="bookChapterSelect"
                className="hw_default_sub_dropdown_size form-select"
                onChange={(e) =>
                  setQuestions((prev) => {
                    const updatedQuestion = {
                      ...prev[nextQuestion],
                      chapter_id: e.target.value,
                      book_id:
                        e.target.options[e.target.selectedIndex].getAttribute(
                          "book-id"
                        ),
                    };
                    const newQuestion = [...prev];
                    newQuestion[nextQuestion] = updatedQuestion;
                    return newQuestion;
                  })
                }
                value={question.chapter_id}
              >
                <option value="null">Select Chapter</option>
                {chapters?.length > 0 &&
                  chapters?.map((bookChapter, index) => (
                    <optgroup
                      label={bookChapter?.name}
                      key={index}
                      bookId={bookChapter?.id}
                    >
                      {bookChapter?.chapters?.length > 0 &&
                        bookChapter?.chapters?.map((chapter, index) => (
                          <option
                            key={index}
                            book-id={bookChapter?.id}
                            book-name={bookChapter?.name}
                            value={chapter?.id}
                          >
                            {chapter?.name}
                          </option>
                        ))}
                    </optgroup>
                  ))}
              </select> */}
            </div>
            {/* <div>&nbsp; &nbsp;</div> */}
          </div>

          <div className="mt-2 hw_default_dropdown_container  d-flex align-ites-center justify-content-between">
            <div className=" d-flex align-items-center gap-5">
              {/* <div className="hw_mandatory_checkbox ">
                <input
                  onChange={() =>
                    setQuestions((prev) => {
                      const updatedQuestion = {
                        ...prev[nextQuestion],
                        is_mandatory: !question.is_mandatory,
                      };
                      const newQuestion = [...prev];
                      newQuestion[nextQuestion] = updatedQuestion;
                      return newQuestion;
                    })
                  }
                  type="checkbox"
                  checked={question.is_mandatory}
                />
                &nbsp;
                <span>Mandatory question</span>
              </div> */}
              <div className="hw_mandatory_checkbox ">
                <input
                  onChange={() =>
                    setQuestions((prev) => {
                      const updatedQuestion = {
                        ...prev[nextQuestion],
                        add_to:
                          prev[nextQuestion].add_to !== "homework"
                            ? "homework"
                            : null,
                      };
                      const newQuestion = [...prev];
                      newQuestion[nextQuestion] = updatedQuestion;
                      return newQuestion;
                    })
                  }
                  type="checkbox"
                  checked={question.add_to === "homework"}
                />
                &nbsp;
                <span>Add for Assessment</span>
              </div>
            </div>
            <div className="gap-3  p-0 time_duration_box d-flex justify-content-between ">
              <div style={{ width: "50%", marginLeft: "9px" }}>
                <span className="hw_default_dropdown_box_header">MARKS</span>
                <input
                  onChange={(e) => {
                    const inputValue = parseInt(e.target.value, 10);
                    //Here I set the marks range min (0) and max (200)
                    if (inputValue >= 0 && inputValue <= 200) {
                      setMarksE(inputValue);
                      setQuestions((prev) => {
                        const updatedQuestion = {
                          ...prev[nextQuestion],
                          correct_score: inputValue
                        };
                        const newQuestion = [...prev];
                        newQuestion[nextQuestion] = updatedQuestion;
                        return newQuestion;
                      });
                    } else if (inputValue > 200) {
                      setMarksE(200);
                      setQuestions((prev) => {
                        const updatedQuestion = {
                          ...prev[nextQuestion],
                          correct_score: 200,
                        };
                        const newQuestion = [...prev];
                        newQuestion[nextQuestion] = updatedQuestion;
                        return newQuestion;
                      });
                      //I added this login inputValue should not be in minus (-1)
                    } else if (inputValue < 0) {
                      setQuestions((prev) => {
                        const updatedQuestion = {
                          ...prev[nextQuestion],
                          correct_score: 0,
                        };
                        const newQuestion = [...prev];
                        newQuestion[nextQuestion] = updatedQuestion;
                        return newQuestion;
                      });
                      setQuestions((prev) => {
                        const updatedQuestion = {
                          ...prev[nextQuestion],
                          correct_score: null,
                        };
                        const newQuestion = [...prev];
                        newQuestion[nextQuestion] = updatedQuestion;
                        return newQuestion;
                      });
                    }
                  }}
                  type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  className="form-control hw_default_sub_dropdown_size"
                  placeholder="Enter Marks"
                  maxLength="3"
                  min="0"
                  max="200"
                  value={question.correct_score}
                />
                <span style={{ color: "red", fontSize: "10px" }}>
                  {/* if mark is already present  */}
                  {question.correct_score === null || "" ? "Marks should be > 0" : ""}
                </span>
              </div>
              <div style={{ width: "50%" }}>
                <span className="hw_default_dropdown_box_header">
                  LEVEL OF DIFFICULTY
                </span>
                <select
                  onChange={(e) =>
                    setQuestions((prev) => {
                      const updatedQuestion = {
                        ...prev[nextQuestion],
                        difficulty_level: e.target.value,
                      };
                      const newQuestion = [...prev];
                      newQuestion[nextQuestion] = updatedQuestion;
                      return newQuestion;
                    })
                  }
                  value={question.difficulty_level}
                  label={
                    difficultyLevels?.some(
                      (d) => d.id === question.difficulty_level
                    ).name
                  }
                  className="form-select hw_default_sub_dropdown_size"
                >
                  <option value="null">Select Difficulty</option>
                  {difficultyLevels &&
                    difficultyLevels.map((difficultyLevel, index) => (
                      <option key={index} value={difficultyLevel.id}>
                        {difficultyLevel.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>
          {
            <div className=" mt-2 hw_default_dropdown_container d-flex ">
              <input
                onChange={(e) => {
                  handleAttachment(e.target.files);
                }}
                multiple
                type="file"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                id={`attachFile${nextQuestion}`}
                style={{ display: "none" }}
              />
              <label
                className="pt-1"
                htmlFor={`attachFile${nextQuestion}`}
                style={{
                  cursor: "pointer",
                  margin: 0,
                }}
              >
                <img src="/images/Attach.svg" alt="" />
                <span className="hw_mandatory_checkbox">&nbsp;Attach</span>
              </label>
              {loader && (
                <img
                  style={{ width: "32px", height: "32px" }}
                  src="/gif/Loader.gif"
                />
              )}

              <span style={{ color: "red" }}>
                {fLimit && "file size should not exceed more than 10 MB"}
              </span>
              {question.attachments.length > 0 &&
                question.attachments.map((attachment, idx) => (
                  <CrossAttachmentAssessment
                    key={idx}
                    attachment={attachment}
                    isEditable={true}
                    setQuestions={setQuestions}
                    nextQuestion={nextQuestion}
                  />
                ))}
            </div>
          }

          {question.question_type !== "" &&
            question.question_type === "false" ? (
            <CreateMcq
              nextQuestion={nextQuestion}
              question={question}
              setQuestions={setQuestions}
            />
          ) : (
            question.question_type !== "null" && (
              <CreateUploadType
                nextQuestion={nextQuestion}
                question={question}
                setQuestions={setQuestions}
              />
            )
          )}
          {
            click && <Guides setClick={setClick} />
          }
        </div>
      </div>
    </>
  );
}
